import React from "react";
import { Box } from "@bca/ui-library";
import AnimatedBox from "./AnimatedBox";

const FilterSkeleton = ({ pairCount = 2 }: { pairCount: number }) => {
  const iterator = Array(pairCount).fill(1);

  return (
    <Box display="flex" flexDirection="column">
      {iterator.map((value, index) => (
        <React.Fragment key={`${value}-${index}`}>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            mb={3}
          >
            <Box display="flex" flexDirection="row">
              <AnimatedBox width="24px" height="24px" mr={3} />
              <AnimatedBox width="120px" height="24px" />
            </Box>
            <AnimatedBox width="48px" height="24px" />
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            mb={3}
          >
            <Box display="flex" flexDirection="row">
              <AnimatedBox width="24px" height="24px" mr={3} />
              <AnimatedBox width="100px" height="24px" />
            </Box>
            <AnimatedBox width="48px" height="24px" />
          </Box>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default FilterSkeleton;
